import React, { useEffect } from "react";
import FloatingLogoAndButton from "../FloatingLogoAndButton/FloatingLogoAndButton";
import { Helmet } from "react-helmet-async";
// 📸 ZDJĘCIA (podstaw później)
// 1. mapa / plantacja tytoniu
import imgRegion from "../../assets/images/bydgoszcz/cigar/plant.jpg";

// 2. budowa cygara (rozłożone)
import imgBuild from "../../assets/images/bydgoszcz/cigar/leaf-tabac.jpg";

// 3. luksusowe cygara / pudełko
import imgBrands from "../../assets/images/bydgoszcz/cigar/famous-cigar.jpg";

// 4. różne kolory cygar (wrapper)
import imgTypes from "../../assets/images/bydgoszcz/cigar/difrent-colors.jpg";

// 5. cygaro + whisky (experience)
import imgExperience from "../../assets/images/bydgoszcz/cigar/cigar-whisky.jpg";

export default function RodzajeCygar() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        {" "}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Article",
            headline: "Rodzaje cygar – jak je rozróżniać?",
            description:
              "Przewodnik po rodzajach cygar, ich budowie i najważniejszych regionach produkcji.",
            author: {
              "@type": "Organization",
              name: "Whitebull Steakhouse",
            },
            mainEntityOfPage: {
              "@type": "WebPage",
              "@id": "https://whitebull.com.pl/rodzaje-cygar",
            },
          })}
        </script>
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: [
              {
                "@type": "Question",
                name: "Jakie są rodzaje cygar?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Cygara różnią się pochodzeniem, kolorem wrappera oraz rozmiarem, np. Robusto czy Churchill.",
                },
              },
              {
                "@type": "Question",
                name: "Jak rozpoznać dobre cygaro?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Dobre cygaro ma gładki wrapper, równą strukturę i spala się równomiernie.",
                },
              },
            ],
          })}
        </script>
      </Helmet>

      <div className="bg-black text-white min-h-screen px-4 py-10">
        <FloatingLogoAndButton />
        <div className="mb-20"></div>

        {/* HERO */}
        <section className="max-w-4xl mx-auto text-center mb-16">
          <h1 className="text-4xl md:text-5xl font-bold mb-6">
            Rodzaje cygar – jak je rozróżniać?
          </h1>
          <p className="text-lg opacity-90">
            Świat cygar to połączenie regionu, konstrukcji i smaku. Poznaj
            najważniejsze typy cygar i naucz się je rozpoznawać.
          </p>
        </section>

        {/* SEKCJA 1 – LEWO OBRAZ */}
        <section className="max-w-6xl mx-auto flex flex-col md:flex-row gap-10 mb-16 items-center">
          <img
            src={imgRegion}
            alt="plantacje tytoniu cygara"
            className="w-full md:w-1/2 h-80 object-cover"
          />

          <div className="md:w-1/2">
            <h2 className="text-2xl font-semibold mb-4">
              🌍 Regiony produkcji cygar
            </h2>
            <ul className="space-y-3 opacity-90">
              <li>
                <strong>Kuba</strong> – najbardziej prestiżowe cygara
              </li>
              <li>
                <strong>Dominikana</strong> – łagodniejsze profile
              </li>
              <li>
                <strong>Nikaragua</strong> – intensywne i mocne
              </li>
              <li>
                <strong>Honduras</strong> – dobrze zbalansowane
              </li>
            </ul>
          </div>
        </section>

        {/* SEKCJA 2 – PRAWO OBRAZ */}
        <section className="max-w-6xl mx-auto flex flex-col md:flex-row-reverse gap-10 mb-16 items-center">
          <img
            src={imgBuild}
            alt="budowa cygara filler binder wrapper"
            className="w-full md:w-1/2 h-80 object-cover"
          />

          <div className="md:w-1/2">
            <h2 className="text-2xl font-semibold mb-4">🧱 Budowa cygara</h2>
            <p className="opacity-90">
              Każde cygaro składa się z trzech elementów: filler, binder i
              wrapper.
            </p>
          </div>
        </section>

        {/* SEKCJA 3 – LEWO */}
        <section className="max-w-6xl mx-auto flex flex-col md:flex-row gap-10 mb-16 items-center">
          <img
            src={imgBrands}
            alt="luksusowe cygara pudełko"
            className="w-full md:w-1/2 h-80 object-cover"
          />

          <div className="md:w-1/2">
            <h2 className="text-2xl font-semibold mb-4">
              🏆 Najbardziej cenione cygara
            </h2>
            <p className="opacity-90">
              Cohiba, Montecristo czy Partagás to marki uznawane na całym
              świecie.
            </p>
          </div>
        </section>

        {/* SEKCJA 4 – PRAWO */}
        <section className="max-w-6xl mx-auto flex flex-col md:flex-row-reverse gap-10 mb-16 items-center">
          <img
            src={imgTypes}
            alt="kolory cygar wrapper"
            className="w-full md:w-1/2 h-80 object-cover"
          />

          <div className="md:w-1/2">
            <h2 className="text-2xl font-semibold mb-4">
              🔍 Jak rozróżniać cygara?
            </h2>
            <p className="opacity-90">
              Kolor, aromat i spalanie pozwalają ocenić jakość cygara.
            </p>
          </div>
        </section>

        {/* SEKCJA 5 – LEWO */}
        <section className="max-w-6xl mx-auto flex flex-col md:flex-row gap-10 mb-16 items-center">
          <img
            src={imgExperience}
            alt="cygaro whisky klimat"
            className="w-full md:w-1/2 h-80 object-cover"
          />

          <div className="md:w-1/2">
            <h2 className="text-2xl font-semibold mb-4">
              🍽️ Cygaro jako doświadczenie
            </h2>
            <p className="opacity-90">
              Cygaro najlepiej smakuje w odpowiednim otoczeniu – z whisky lub
              bourbonem.
            </p>
          </div>
        </section>

        {/* CTA */}
        <section className="text-center mb-12">
          <a href="/palarnia-cygar-bydgoszcz" className="underline text-lg">
            → Zobacz palarnię cygar w Whitebull
          </a>
        </section>
      </div>
    </>
  );
}
